// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__-orki","modal":"Modal_modal__fX2Im","slide-down":"Modal_slide-down__Mu4zh"};